import React, { useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import enUS from "date-fns/locale/en-US";
import { FormattedMessage } from "react-intl";
import { LANG } from "constants/constants";
import "./InputDate.scss";
import { parseValue } from "utils/helper";
import ErrorPopupBtn from "components/alert-popup/ErrorPopupBtn";
import { ErrorPopup } from "components/alert-popup/ErrorPopup";

registerLocale("fr", fr);
registerLocale("en", enUS);

const InputDate = ({
  clearErrors,
  id,
  label,
  onChange,
  readOnly,
  required,
  value,
  showDatepicker = true,
  lang = LANG.EN,
  enableBoldWhenFilled,
  ...props
}) => {
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const handleDateChange = (date) => {
    if (onChange) {
      const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
      onChange({ target: { value: formattedDate } });
    }
  };

  const renderLabel = () => {
    if (!label) return null;
    return (
      <div
        className={`overlap-group ${label && "justify-input-text"}
      ${props?.errors?.ref && "error"}

      `}
      >
        <div className="label sourcesanspro-normal-shadow-blue-14px error">
          <label
            className={props?.errors?.ref ? "label-error" : "label-standard"}
          >
            <FormattedMessage
              id={label.id || label}
              defaultMessage={label.defaultMessage || label}
            />
            {required && "*"}
          </label>
          {props?.errors && (
            <ErrorPopupBtn setShowErrorPopup={setShowErrorPopup} />
          )}
          {showErrorPopup && (
            <ErrorPopup
              errors={props?.errors}
              showErrorPopup={showErrorPopup}
              setShowErrorPopup={setShowErrorPopup}
              label={label}
              errorMessage={props?.errors?.message || props?.errorMessage}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderLabel()}
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
        }}
        data-testid={props.name}
      >
        <DatePicker
          className={`sourcesanspro-normal-gray-suit-18pxmt-10 ${
            enableBoldWhenFilled && value ? "classname-date-input" : ""
          }`}
          scrollableMonthYearDropdown={true}
          yearDropdownItemNumber={12}
          dropdownMode="select"
          showMonthDropdown={true}
          showYearDropdown={true}
          id={id}
          selected={parseValue(value)}
          onChange={handleDateChange}
          onMonthChange={handleDateChange}
          onYearChange={handleDateChange}
          locale={lang === LANG.EN ? "en" : "fr"}
          dateFormat={lang === LANG.EN ? "MM/dd/yyyy" : "dd/MM/yyyy"}
          disabled={readOnly}
          placeholderText={lang === LANG.EN ? "MM/DD/YYYY" : "JJ/MM/AAAA"}
          {...props}
        />
      </div>
    </div>
  );
};

InputDate.propTypes = {
  id: PropTypes.any.isRequired,
  label: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  lang: PropTypes.string,
  showDatepicker: PropTypes.bool,
  enableBoldWhenFilled: PropTypes.bool,
  errors: PropTypes.shape({
    ref: PropTypes.any,
    message: PropTypes.string,
  }),
};

InputDate.defaultProps = {
  label: null,
  onChange: null,
  readOnly: false,
  required: false,
  value: null,
  lang: LANG.EN,
};

export default InputDate;
